export default __webpack_public_path__ + "static/bannerbox.wedl-6e2c70b29d1cdcc368cecb195ba944fb.jpg";